// dummyOptions.js
export const jabatan = [
  "Lead Field Agent",
  "Field Agent",
  "Fullstack Developer",
  "Biotechnologiez",
  "Admin",
  "General Admin",
  "HR Admin",
  "Agronomist",
  "Finance Admin",
];

export const status = ["Anggota", "Non Anggota", "Pengelola", "Pelopor"];

export const roles = [
  "Super Admin",
  "Admin",
  "Admin HR",
  "Admin Finance",
  "Field Agent",
  "R&D",
  "Marketing",
  "Mitra",
];

export const statusmitra = [
    "Anggota",
    "Non Anggota",
]
